// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 984 ? "reactPlayerPreview" : chunkId) + "." + {"808":"7eda4542","984":"685644fe"}[chunkId] + ".chunk.js";
};